module.exports = __webpack_public_path__ + "static/VersionMobileLogo-c58a79e5e5280e52f0e0dbd94d1df4db.png";